import styled from 'styled-components';
import Tabs from '../../Tabs';
import { prefix } from '../../../tools/settings';
var ModalTabs = styled(Tabs).withConfig({
  displayName: "Tabsstyles__ModalTabs",
  componentId: "sc-1n878hu-0"
})(["flex:1;display:flex;flex-direction:column;overflow:hidden;.", "-tabs__tab-panels{flex:1;overflow:auto;}"], prefix);
var ModalTabList = styled(Tabs.List).withConfig({
  displayName: "Tabsstyles__ModalTabList",
  componentId: "sc-1n878hu-1"
})(["margin-bottom:0;padding:var(--dentsu-spacing-24) var(--dentsu-spacing-48) 0;"]);
var ModalTab = styled(Tabs.Tab).withConfig({
  displayName: "Tabsstyles__ModalTab",
  componentId: "sc-1n878hu-2"
})([""]);
var ModalTabPanels = styled(Tabs.Panels).withConfig({
  displayName: "Tabsstyles__ModalTabPanels",
  componentId: "sc-1n878hu-3"
})([""]);
var ModalTabPanel = styled(Tabs.Panel).withConfig({
  displayName: "Tabsstyles__ModalTabPanel",
  componentId: "sc-1n878hu-4"
})(["padding:var(--dentsu-spacing-32) var(--dentsu-spacing-48) var(--dentsu-spacing-48);"]);
export var Styled = {
  ModalTabs: ModalTabs,
  ModalTabList: ModalTabList,
  ModalTab: ModalTab,
  ModalTabPanels: ModalTabPanels,
  ModalTabPanel: ModalTabPanel
};